import imageCompression, { Options } from "browser-image-compression";
import workerUrl from 'browser-image-compression/dist/browser-image-compression.js?url';

export const compressImage = async (file: File): Promise<Blob> => {
  try {
    const options: Options = {
    maxSizeMB: 0.5,
    useWebWorker: true,
    libURL: workerUrl,
  };
    const compressedFile = await imageCompression(file, options);
    return compressedFile;
  } catch (error) {
    console.warn('Image compression failed, using original:', error);
    return file;
  }
};

export function uint8ArrayToBase64(uint8Array: Uint8Array) {
  let binary = "";
  uint8Array.forEach((byte) => (binary += String.fromCharCode(byte)));
  return btoa(binary);
}

// export function base64ToBlob(base64: string, contentType: string = '', sliceSize: number = 512): Blob {
//   const byteCharacters = atob(base64);
//   const byteArrays: Uint8Array[] = [];

//   for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
//       const slice = byteCharacters.slice(offset, offset + sliceSize);
//       const byteNumbers = new Array(slice.length);

//       for (let i = 0; i < slice.length; i++) {
//           byteNumbers[i] = slice.charCodeAt(i);
//       }

//       const byteArray = new Uint8Array(byteNumbers);
//       byteArrays.push(byteArray);
//   }

//   return new Blob(byteArrays, { type: contentType });
// }

export const blobToBase64 = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64data = reader.result as string;
      resolve(base64data.split(',')[1]); // Return only the base64 part
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};